enum AddressFlagEnum {
    CONTACT = "CONTACT",
    PERMANENT = "PERMANENT",
}

export default AddressFlagEnum;
